import { Box, Stack, Typography } from "@mui/material"
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined'
import PrintDisabledRoundedIcon from '@mui/icons-material/PrintDisabledRounded'
import OpcaoCard from "../../components/opcao-card"

interface ImpressaoPerguntaProps {
    onImprimir: () => void
    onPular: () => void
}

export default function ImpressaoPergunta({ onImprimir, onPular }: ImpressaoPerguntaProps): JSX.Element {
    return (
        <Stack spacing={4} sx={{ alignItems: 'center', width: '100%' }}>
            <Typography variant="h4" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                Deseja imprimir a nota fiscal?
            </Typography>

            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 3, width: '100%', maxWidth: 620 }}>
                <OpcaoCard
                    icone={<LocalPrintshopOutlinedIcon sx={{ fontSize: 64, color: 'success.main' }} />}
                    rotulo="Sim, imprimir"
                    onClick={onImprimir}
                />

                <OpcaoCard
                    icone={<PrintDisabledRoundedIcon sx={{ fontSize: 64, color: 'text.secondary' }} />}
                    rotulo="Não, obrigado"
                    onClick={onPular}
                />
            </Box>
        </Stack>
    )
}